/**
 * Whether this project can take a Right of Withdrawal notice. Derived
 * server-side from `NORCE_WITHDRAWAL_NOTIFICATION_EMAIL` (the address itself is
 * never exposed). Every link to `/right-of-withdrawal` gates on it: without
 * the gate, merging the feature would put the link on every client site, and
 * on an unconfigured project the customer would fill the form in and hit a
 * 503. See docs/RIGHT-OF-WITHDRAWAL.md.
 */
export const useWithdrawalEnabled = () => {
	const config = useRuntimeConfig();
	return computed(() => Boolean(config.public?.norce?.withdrawal?.enabled));
};
